import {Asistente} from './asistente';
import {Usuario} from '../intranet/model/usuario';

export class ClienteSesion {
  public token: string;
  public asistente: Asistente;
  public usuario: Usuario;
}
